import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const proofPoints = ['Web a medida', 'Carta digital', 'Gestión incluida'];
const principles = [['01', 'Estrategia útil', 'Una estructura definida antes de diseñar.'], ['02', 'Diseño con intención', 'Cada sección facilita una decisión.'], ['03', 'Base preparada', 'Una presencia que puedes seguir cuidando.']];
export function Hero() {
  return <section className="border-b border-white/10 bg-[#0a0a0a] pt-24 sm:pt-28" data-id="element-25" data-mp="x9uqrn89208u">
      <div className="container mx-auto px-6 md:px-12" data-id="element-26" data-mp="sbb2vha3iedu">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="mx-auto max-w-5xl py-16 sm:py-24 lg:py-32" data-id="element-27" data-mp="s9q75oc1opee">
          <div className="flex items-center gap-4" data-id="element-28" data-mp="382ffxqfwf8fz">
            <p className="eyebrow" data-id="element-29" data-mp="380vy3velgpc3">Growthly · agencia digital</p>
            <span className="h-px w-10 bg-white/20" aria-hidden="true" data-id="element-30" data-mp="3j7zhzqi0g6kd" />
          </div>
          <h1 className="mt-6 max-w-4xl text-5xl font-medium leading-[0.98] tracking-[-0.06em] text-white sm:text-6xl lg:text-7xl" data-id="element-31" data-mp="3o7c05xxxspgm">
            Tu negocio merece una presencia que esté a su altura.
          </h1>
          <div className="mt-8 grid gap-8 border-t border-white/10 pt-7 lg:grid-cols-[minmax(0,1fr)_minmax(220px,0.48fr)] lg:gap-14" data-id="element-32" data-mp="3e8mtl1bhqrfo">
            <div data-id="element-33" data-mp="30ggfrlvt8wje">
              <p className="max-w-2xl text-base leading-relaxed text-neutral-400 sm:text-lg" data-id="element-34" data-mp="30fy8zvbiuzx8">
                Diseñamos una base digital clara para que tus clientes entiendan
                tu valor, encuentren lo importante y sepan cómo avanzar.
              </p>
              <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-35" data-mp="2vjpy4u4cxsvv">
                <Link to="/checkout" className="button-primary group sm:min-w-[190px]" data-id="element-36" data-mp="2hinbaf5jgejw">
                  Iniciar mi proyecto
                  <ArrowRightIcon size={17} className="transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-37" data-mp="2ljgyf6b5ppbq" />
                </Link>
                <Link to="/proceso" className="button-secondary sm:min-w-[150px]" data-id="element-38" data-mp="n9i4bdr5fgun">
                  Ver el proceso
                </Link>
              </div>
            </div>
            <div className="border-l border-white/10 pl-5 sm:pl-6" data-id="element-39" data-mp="deq7wd9az01g">
              <p className="text-[10px] font-medium uppercase tracking-[0.2em] text-neutral-600" data-id="element-40" data-mp="1b15pdf1qbxp0">
                Una propuesta, un objetivo
              </p>
              <p className="mt-4 text-sm leading-relaxed text-neutral-300" data-id="element-41" data-mp="15zzwnh82kafh">
                Ordenar tu mensaje, elevar la percepción de tu marca y facilitar
                la siguiente conversación.
              </p>
            </div>
          </div>
          <div className="mt-10 flex flex-wrap gap-x-5 gap-y-3 border-t border-white/10 pt-5" data-id="element-42" data-mp="3lu026z6yb0yo">
            {proofPoints.map(point => <span key={point} className="inline-flex items-center gap-2 text-xs font-medium text-neutral-300" data-id="element-43" data-mp="3htg5fwqahzd2">
                <CheckIcon size={14} className="text-white" aria-hidden="true" data-id="element-44" data-mp="21bpmjgknzt1q" />
                {point}
              </span>)}
          </div>
        </motion.div>
      </div>

      <div className="border-t border-white/10 bg-black" data-id="element-45" data-mp="2b0zcoqvy71n7">
        <div className="container mx-auto grid px-6 md:px-12 sm:grid-cols-3" data-id="element-46" data-mp="2b2kcaux4darx">
          {principles.map(([number, title, detail]) => <article key={number} className="border-b border-white/10 py-6 last:border-b-0 sm:border-b-0 sm:border-r sm:px-7 sm:first:pl-0 sm:last:border-r-0" data-id="element-47" data-mp="2ky42r1swzh9a">
              <p className="text-[10px] font-medium tracking-[0.2em] text-neutral-600" data-id="element-48" data-mp="2tztrfzvew23d">
                {number}
              </p>
              <h2 className="mt-4 text-sm font-medium text-white" data-id="element-49" data-mp="uoakfqto53wc">{title}</h2>
              <p className="mt-1 text-xs leading-relaxed text-neutral-500" data-id="element-50" data-mp="zmc34an6n17a">
                {detail}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}